import { File, FileNameTypes, FileUploadStatus, ReportDetailsQuery } from '@/__generated__/graphql';
import { SelectableImage } from '../SelectableImage';
import { getCloudfrontUrl } from '@/utils/cloudfront';
import { Dispatch, SetStateAction, useMemo } from 'react';
import { createFileObjectFromScreenShotPath } from '@/utils/reports';

type Props = {
  pois: ReportDetailsQuery['report']['pointOfInterests'];
  reportFiles: ReportDetailsQuery['report']['files'];
  setImagesToDetach: Dispatch<SetStateAction<string[]>>;
  imagesToDetach: string[];
};
export const AttachedImages = ({ imagesToDetach, setImagesToDetach, pois, reportFiles }: Props) => {
  const allPoiImages = useMemo(() => {
    const attachments: File[] = (pois ?? [])?.flatMap((poi) => {
      return (poi.files ?? [])?.filter(({ uploadStatus, name }) => {
        if (uploadStatus !== FileUploadStatus.Success) return false;
        return name === FileNameTypes.PoiScreenshot || name === FileNameTypes.PoiAttachments;
      });
    });

    const viewerScreenshots: File[] = pois
      ?.filter((poi) => poi?.screenshotPaths?.viewer)
      ?.map((poi) =>
        createFileObjectFromScreenShotPath({
          poiName: poi.name ?? poi.type.toLowerCase(),
          poiId: poi.poiId,
          resourcePath: poi?.screenshotPaths?.viewer,
          imageType: 'viewer',
        })
      )
      .filter((file) => file !== undefined) as File[];

    const viewpointScreenshots: File[] = pois
      ?.filter((poi) => poi?.screenshotPaths?.viewpoint)
      ?.map((poi) =>
        createFileObjectFromScreenShotPath({
          poiName: poi?.name ?? poi.type.toLowerCase(),
          poiId: poi.poiId,
          resourcePath: poi?.screenshotPaths?.viewpoint,
          imageType: 'viewpoint',
        })
      )
      .filter((file) => file !== undefined) as File[];

    return [...attachments, ...viewerScreenshots, ...viewpointScreenshots];
  }, [pois]);

  return (
    <>
      {(reportFiles || [])
        .filter((file) =>
          allPoiImages.some((poiImage) => poiImage.resourcePath === file.resourcePath)
        )
        .map((file) => {
          return (
            <>
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                <SelectableImage
                  imgProps={{
                    src: getCloudfrontUrl(file.resourcePath),
                    width: '100%',
                  }}
                  overlayVisible={Boolean(
                    !imagesToDetach?.some((fileName) => fileName === file.id)
                  )}
                  onClick={() => {
                    setImagesToDetach((prev) => {
                      const imageIndex = prev.indexOf(file.id || '');
                      if (imageIndex === -1) {
                        return [...prev, file.id || ''];
                      }
                      return prev.filter((_, i) => i !== imageIndex);
                    });
                  }}
                />
              </div>
            </>
          );
        })}
    </>
  );
};
